import { useIntl } from 'react-intl';

import { TerminalWorkflowType } from '../../../../api/terminals';
import ActionCard from '../../../../components/domain/ActionCard';
import { AllowedActionViewProps } from '../../../../components/domain/AllowedAction';
import useTerminal from '../../../../hooks/useTerminal';
import { isDelivery } from '../../../../services/contact/GlobalPermissions';
import HelpWorkflow from '../../../nike/HelpWorkflow';

type NikeHelpWorkflowActionProps = AllowedActionViewProps;

function NikeHelpWorkflowAction(props: NikeHelpWorkflowActionProps) {
    const intl = useIntl();
    const terminal = useTerminal();
    if (terminal === null || props.contact === undefined) return undefined;
    if (
        !(
            // ALLOWED cases
            (terminal.workflow === TerminalWorkflowType.IMES_DEXIS_NIKE && !isDelivery(props.contact))
        )
    )
        return undefined;

    const nikeHelpWorkflowAction: ActionCard = {
        actionText: intl.formatMessage({
            id: 'workflow.nike.DashboardWorkflow.NeedHelpAction',
            description: 'This is the help action on the Nike dashboard',
            defaultMessage: 'Need help?',
        }),
        icon: <i className='bi bi-question-circle dashboard-action-icon' />,
        view: (
            <HelpWorkflow
                loggedInContact={props.contact}
                onInactivity={props.onInactivity}
                onHome={props.onHome}
            />
        ),
    };

    return nikeHelpWorkflowAction;
}

export default NikeHelpWorkflowAction;
